import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { authFetch } from '../lib/authFetch';

export interface Budget {
  _id: string;
  category: string;
  amount: number;
  startDate: string;
  endDate?: string;
  frequency: 'monthly' | 'weekly' | 'custom';
  createdByRole: 'primary' | 'partner' | 'super admin';
}

export const useBudgets = (refreshKey = 0) => {
  const { auth } = useAuth();
  const [budgets, setBudgets] = useState<Budget[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBudgets = async () => {
      setLoading(true);
      try {
        const res = await authFetch('/api/budgets', {
          headers: { Authorization: `Bearer ${auth.token}` },
        });
        const data = await res.json();
        setBudgets(data);
      } catch (err) {
        console.error('Budget fetch error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchBudgets();
  }, [auth.token, refreshKey]);

  return { budgets, loading };
};
